import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(() => {
    return {
        container: {
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 20px',
            backgroundColor: '#DC3545',
            borderRadius: '50px',
            boxShadow: '0 8px 24px rgba(220, 53, 69, 0.4)',
            zIndex: 1001,
            animation: 'pulse 1s ease-in-out infinite',
            '@media (max-width: 768px)': {
                bottom: 'auto',
                top: '80px',
                left: '50%',
                right: 'auto',
                transform: 'translateX(-50%)',
                padding: '10px 18px'
            }
        },
        icon: {
            fontSize: '1.2rem',
            animation: 'blink 1s ease-in-out infinite'
        },
        text: {
            fontSize: '0.9rem',
            fontWeight: 600,
            color: '#fff',
            margin: 0,
            whiteSpace: 'nowrap'
        },
        countdown: {
            fontSize: '1.1rem',
            fontWeight: 700,
            color: '#fff',
            minWidth: '24px',
            textAlign: 'center'
        },
        '@keyframes pulse': {
            '0%, 100%': {
                transform: 'scale(1)',
                boxShadow: '0 8px 24px rgba(220, 53, 69, 0.4)'
            },
            '50%': {
                transform: 'scale(1.05)',
                boxShadow: '0 12px 32px rgba(220, 53, 69, 0.6)'
            }
        },
        '@keyframes blink': {
            '0%, 100%': {
                opacity: 1
            },
            '50%': {
                opacity: 0.3
            }
        },
        '@media (max-width: 768px)': {
            '@keyframes pulse': {
                '0%, 100%': {
                    transform: 'translateX(-50%) scale(1)',
                    boxShadow: '0 8px 24px rgba(220, 53, 69, 0.4)'
                },
                '50%': {
                    transform: 'translateX(-50%) scale(1.05)',
                    boxShadow: '0 12px 32px rgba(220, 53, 69, 0.6)'
                }
            }
        }
    };
});
const FinalCountdown = ({ secondsRemaining }) => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    const [seconds, setSeconds] = useState(secondsRemaining);
    useEffect(() => {
        setSeconds(secondsRemaining);
    }, [secondsRemaining]);
    useEffect(() => {
        if (seconds <= 0) {
            return;
        }
        const timer = setInterval(() => {
            setSeconds(prev => Math.max(0, prev - 1));
        }, 1000);
        return () => clearInterval(timer);
    }, [seconds]);
    return (React.createElement("div", { className: classes.container },
        React.createElement("span", { className: classes.countdown }, seconds),
        React.createElement("span", { className: classes.text }, t('roomTimeLimit.endingIn')),
        React.createElement("span", { className: classes.icon }, "\u26A0\uFE0F")));
};
export default FinalCountdown;
